import { render, staticRenderFns } from "./TeachersListPage.vue?vue&type=template&id=63a4e2b6&"
import script from "./TeachersListPage.vue?vue&type=script&lang=ts&"
export * from "./TeachersListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports